<template>
    <div style="background: #171717">
        <v-row align="center" justify="center">
            <v-col cols="12">
                <p class="caption text-center" style="color: #A8A7A7">©2020 EVAScopes The best telescopes for astrophotography in Chile.</p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    
}
</script>